import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';

type DataTableDeleteModalProps = {
  count: number;
  itemName: string;
  onConfirm: () => void;
};

export function openDataTableDeleteModal({ count, itemName, onConfirm }: DataTableDeleteModalProps) {
  const plural = count === 1 ? '' : 's';

  modals.openConfirmModal({
    title: `Delete ${itemName}${plural}?`,
    children: (
      <Text>
        This will permanently delete <span className="font-semibold">{count}</span> {itemName}
        {plural}
      </Text>
    ),
    labels: { confirm: 'Delete', cancel: 'Cancel' },
    onConfirm,
    confirmProps: { color: 'red' },
    centered: true,
    size: 'xs',
    zIndex: 320,
  });
}
